import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateObligationInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export type UpdateObligationInternalAuditResultInput = {
  Id: string;
  Rating?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

const mapTrpcResponseToGraphQL =
  (): UpdateObligationInternalAuditResultMutation => ({
    update_obligation_internal_audit_result: {
      __typename: 'obligation_internal_audit_result_mutation_response',
      affected_rows: 1,
    },
  });

export const useUpdateObligationInternalAuditResultTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.internalAuditResult.updateObligation.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.internalAuditResult.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.assessment.internalAuditResultCount.queryKey(),
          }),
        ]);
      },
    }),
  });

  return {
    updateObligationInternalAuditResult: async (
      variables: UpdateObligationInternalAuditResultInput
    ): Promise<UpdateObligationInternalAuditResultMutation> => {
      await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL();
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
